import RouteHandler from './RouteHandler';

export default RouteHandler;
